import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { countryOptions } from "@/lib/countries";

/** Hidden honeypot field: real visitors never see or fill it. */
export const HoneypotField = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) => (
  <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", top: "auto", width: 1, height: 1, overflow: "hidden" }}>
    <label>
      Website
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  </div>
);

/** Country dropdown (ISO code value) with the main markets on top. */
export const CountrySelect = ({
  value,
  onChange,
  className,
  autoFocus,
}: {
  value: string;
  onChange: (code: string) => void;
  className?: string;
  autoFocus?: boolean;
}) => {
  const { t, i18n } = useTranslation();
  const { priority, rest } = useMemo(() => countryOptions(i18n.language), [i18n.language]);
  return (
    <select
      autoFocus={autoFocus}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={t("sLeadFields.country")}
      className={className}
    >
      <option value="" className="text-black">
        {t("sLeadFields.country")}
      </option>
      {priority.map((c) => (
        <option key={c.code} value={c.code} className="text-black">
          {c.label}
        </option>
      ))}
      <option disabled className="text-black">──────────</option>
      {rest.map((c) => (
        <option key={c.code} value={c.code} className="text-black">
          {c.label}
        </option>
      ))}
    </select>
  );
};
